import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {DxTreeListComponent} from 'devextreme-angular';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {FusionAuthService} from '../../../../../../shared/services/fusion-auth';
import {ScreenService, UrlProviderService} from '../../../../../../shared/services/general';
import {ResultBase} from '../../../models/results';
import {OrdersService} from '../../../../../shared/services/orders.service';

@Component({
  selector: 'app-toxicology-expected',
  templateUrl: './toxicology-expected.component.html',
  styleUrls: ['./toxicology-expected.component.scss']
})
export class ToxicologyExpectedComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('toxiExpectedTree', {static: true}) private tree?: DxTreeListComponent;
  @Input() public orderId: number = -1;
  public isLoading = false;
  public dataSource: ResultBase[] = [];
  public hasResults = false;
  public isPhoneOrTablet: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private ordersService: OrdersService,
    private urlProvider: UrlProviderService,
    private fusionAuthService: FusionAuthService,
    private screen: ScreenService
  ) {
  }

  public ngOnInit() {
    this.isLoading = true;
    this.ordersService.getOrderToxicologyConsistentResults(this.orderId)
      .subscribe(result => {
        if (result.length > 0) {
          this.hasResults = true;
          this.dataSource = result;
        } else {
          this.hasResults = false;
        }
      });

    this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete()
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderId.currentValue) {
      this.isLoading = true;
      this.ordersService.getOrderToxicologyConsistentResults(changes.orderId.currentValue)
        .subscribe(result => {
          if (result.length > 0) {
            this.hasResults = true;
            this.dataSource = result;
          } else {
            this.hasResults = false;
          }
        });
    }
  }
}
